import script from "./DialogTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogTwo.vue?vue&type=script&setup=true&lang=js"

import "./DialogTwo.vue?vue&type=style&index=0&id=037b27a7&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037b27a7"]])

export default __exports__